import { useMemoizedFn } from 'ahooks';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { debounce } from 'lodash-es';
import { paneHeightCache } from 'services/cache';

const sync2Storage = debounce((value: number) => {
  paneHeightCache.set(value);
}, 500);

const paneHeightState = atom(paneHeightCache.get<number>() || 210);

export const usePaneHeight = () => useAtomValue(paneHeightState);
export const useSetPaneHeight = () => {
  const update = useSetAtom(paneHeightState);

  return useMemoizedFn((value: number, syncStorage = false) => {
    update(value);
    if (syncStorage) {
      sync2Storage(value);
    }
  });
};
